import {API} from 'aws-amplify';

export * from './host';

export const removeHosts = async (id, eventHostId) =>
  API.del('eventmanagerAdminApi', `/events/${id}/hosts/${eventHostId}`, {});

export const addHosts = async (id, hosts) =>
  API.put('eventmanagerAdminApi', `/events/${id}/hosts`, {body: {hosts}});

export const readHosts = async (id) => API.get('eventmanagerAdminApi', `/events/${id}/hosts`, {});
